import { styled } from "@mui/material";
import { StyledButton } from "./styled-button";

export const StyledWhiteButton = styled(StyledButton)(({ theme }) => ({
  background: theme.palette.background.white,
  "&::after": {
    background: theme.palette.background.darkBeige,
  },
  "&:hover": {
    background: theme.palette.background.white,
  },
}));

const WhiteButton = ({ ...props }) => {
  return <StyledWhiteButton {...props} />;
};

export default WhiteButton;